import {lazy} from 'react';
import GenericFallbackSuspense from '../../../ui/GenericFallback/GenericFallbackSuspense';

const AddressTypeButtons = lazy(() => import('./AddressTypeButtons'/* webpackChunkName: 'AddressTypeButtons' */));

export default function AddressTypeButtonsLazyLoader(props) {
  return (
    <GenericFallbackSuspense>
      <AddressTypeButtons {...props} />
    </GenericFallbackSuspense>
  );
}
